
export default {
  name: 'TitleStars',
  props: {
    reviews: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    loadingReviews: {
      type: Boolean,
      required: true,
    }
  },
  data () {
    return {
      loading: true,
      hasBeenSsr: false
    }
  },
  computed: {
    defaultScore () {
      return 0
    },
    score () {
      return this.reviews?.bottomline?.average_score ?? this.defaultScore
    },
    count () {
      return this.reviews?.bottomline?.total_review
    },
    hasReviews () {
      return !(this.reviews === null || this.reviews?.reviews?.length === 0)
    },
  },
  watch: {
    loadingReviews (val) {
      if (val === false) {
        this.loading = val
      }
    }
  },
}
